import styled from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const DataIndicator = styled.div<{ primary?: boolean }>`
  width: 10px;
  height: 10px;
  min-width: 10px;
  border-radius: 100%;
  background-color: ${(props) => (props.primary ? '#FF600F' : '#ADAFB2')};
  margin-right: 8px;
`;

export const MainDataValue = styled.div<{ fontSize?: number }>`
  font-size: ${({ fontSize }) => `${fontSize || 33}px`};
  font-weight: 500;
  line-height: 33px;
  color: ${colors.grey7};
`;

export const GrowIndicator = styled(ApIcon)<{ grow?: boolean }>`
  margin-left: -8px;
  margin-top: 4px;
`;

export const TopData = styled.div`
  display: flex;
  position: relative;
  margin-top: 8px;
  width: 100%;
`;

export const BottomData = styled.div`
  display: flex;
  position: relative;
  margin-top: 10px;
`;
